import React, { Component, Fragment } from "react"
import { Redirect } from "react-router-dom"
import { Container, Row, Col, CardBody, Card, CardTitle, Button } from "reactstrap"
import { accessRole } from "../../../../helpers/access_role"
import DetailBloc from './Blocs/DetailBloc'
import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/master/templateSuratService.jsx'

class DetailView extends Component {
    detailBloc = new DetailBloc()
    source

    constructor(props) {
        super(props)
        this.state = {
            uuid: new URLSearchParams(props.location.search).get('uuid'),
            detail: null,
            loading: true,
            redirect: false
        }
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel()
        }
        this.source = cancelToken()
        this.loadDetail()
    }

    loadDetail = async () => {
        await this.detailBloc.fetchDetail({ uuid: this.state.uuid }, this.source.token)
    }

    componentDidMount() {
        if (!accessRole('view')) {
            this.setState({ redirect: true })
        }

        this.setTokenAPI()

        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        this.setState({
                            detail: result.data.response,
                            loading: false
                        })
                    }
                    break
                case apiResponse.ERROR:
                    this.setState({ loading: false })
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.detailBloc.detailChannel.unsubscribe()
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to="?template-surat" />
        }

        const detail = this.state.detail

        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="8">
                            <Card>
                                <CardBody>
                                    <CardTitle className="mb-4">Detail Template Surat</CardTitle>

                                    {this.state.loading ? (
                                        <div className="alert alert-info">Memuat data...</div>
                                    ) : detail ? (
                                        <>
                                            <Row className="mb-3">
                                                <Col md="6">
                                                    <div className="border rounded p-3">
                                                        <strong>Nama Template</strong>
                                                        <p className="text-muted">{detail.nama_template}</p>
                                                    </div>
                                                </Col>
                                                <Col md="6">
                                                    <div className="border rounded p-3">
                                                        <strong>Jenis Surat</strong>
                                                        <p className="text-muted">{detail.jenis_surat}</p>
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col md="12">
                                                    <div className="border rounded p-3">
                                                        <strong>File Template</strong>
                                                        {detail.file_template ? (
                                                            <div>
                                                                <a
                                                                    href={detail.file_template}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-sm btn-info mt-2"
                                                                >
                                                                    <i className="uil-download-alt"></i> Download Template
                                                                </a>
                                                            </div>
                                                        ) : (
                                                            <p className="text-muted mt-2">Tidak ada file</p>
                                                        )}
                                                    </div>
                                                </Col>
                                            </Row>

                                            <div className="mt-4">
                                                {accessRole('update') && (
                                                    <Button
                                                        color="warning"
                                                        onClick={() => this.setState({ redirect: true })}
                                                        className="me-2"
                                                    >
                                                        Edit
                                                    </Button>
                                                )}
                                                <Button
                                                    color="secondary"
                                                    onClick={() => window.history.back()}
                                                >
                                                    Kembali
                                                </Button>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="alert alert-warning">Data tidak ditemukan</div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

export default DetailView
